module.exports = __webpack_public_path__ + "static/Worker_01-1987+2011.37a86c97.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/images/project2/Worker_01-1987+2011.jpg
// module id = 496
// module chunks = 8418805283199